import React from 'react';

export const isValidEmailAddress = {
    name: 'isValidEmailAddress',
    test: (value: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
    errorMessage: 'be a valid email address',
};

export const isNotUsersEmailAddress = {
    name: 'isNotUsersEmailAddress',
    test: (value: string, args: { usersEmail: string }): boolean =>
        value.toLowerCase() !== args.usersEmail.toLowerCase(),
    errorMessage: 'not be your own email address',
};

export const hasSpecialCharacter = {
    name: 'hasSpecialCharacter',
    test: (value: string): boolean =>
        /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`]/.test(value),
    errorMessage: (
        <>
            contain one of these special characters:
            <div>
                <code>
                    {
                        '^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' : ; | _ ~ `'
                    }
                </code>
            </div>
        </>
    ),
};

export const isBetweenEightAndNinetyNineCharacters = {
    name: 'isBetweenEightAndNinetyNineCharacters',
    test: (value: string): boolean => value.length >= 8 && value.length <= 99,
    errorMessage: 'be between 8 and 99 characters long',
};

export const containsNumber = {
    name: 'containsNumber',
    test: (value: string): boolean => /[0-9]/.test(value),
    errorMessage: 'contain a number',
};

export const containsLowercaseLetter = {
    name: 'containsLowercaseLetter',
    test: (value: string): boolean => /[a-z]/.test(value),
    errorMessage: 'contain a lowercase letter',
};

export const containsUppercaseLetter = {
    name: 'containsUppercaseLetter',
    test: (value: string): boolean => /[A-Z]/.test(value),
    errorMessage: 'contain an uppercase letter',
};

export const isNotEmptyString = {
    name: 'isNotEmptyString',
    test: (value: string): boolean => value.length > 0,
    errorMessage: 'be included',
};

export const isPositiveInteger = {
    name: 'isPositiveInteger',
    test: (value: string): boolean => /^[0-9]*$/.test(value),
    errorMessage: 'be a positive number',
};

export const isValidDateMinutesOrSeconds = {
    name: 'isValidDateMinutesOrSeconds',
    test: (value: string): boolean => /^([0-5])?([0-9])$/.test(value),
    errorMessage: 'must be a number between 0 and 59',
};

export const isValidDateHours = {
    name: 'isValidDateHours',
    test: (value: string): boolean => /^2[0-3]$|^[0-1]?[0-9]$/.test(value),
    errorMessage: 'must be a number between 0 and 23',
};

export const isValidDateYear = {
    name: 'isValidDateYear',
    test: (value: string): boolean => /^[0-4]{4}$/.test(value),
    errorMessage: 'must be a 4-digit number',
};

export const isValidDateMonth = {
    name: 'isValidDateMonth',
    test: (value: string): boolean => /^1[0-2]$|^0?[0-9]$/.test(value),
    errorMessage: 'must be a number between 1-12',
};

export const isValidDateDay = {
    name: 'isValidDateDay',
    test: (value: string): boolean => /^3[0-1]$|^[0-2]?[0-9]$/.test(value),
    errorMessage: 'must be a number between 1-31',
};

export const containsNoSpaces = {
    name: 'containsNoSpaces',
    test: (value: string): boolean => /^[^ ]*$/.test(value),
    errorMessage: 'not include spaces',
};
